import React, { FC } from 'react'

import { CSSProperties } from 'styled-components'
import { ButtonProps } from '@mui/material/Button/Button'
import { Button, Box, CircularProgress } from '@mui/material'

interface AppSubmitCancelButtonsProps {
	onCancel?: React.MouseEventHandler<HTMLButtonElement>
	loading?: boolean
	cancelButtonProps?: ButtonProps
	saveButtonProps?: ButtonProps
	saveButtonType?: 'submit' | 'button' | 'reset'
	saveButtonLabel?: string
	cancelButtonLabel?: string
	customWrapperStyles?: CSSProperties
	customButtonStyles?: CSSProperties
}

const AppSubmitCancelButtons: FC<AppSubmitCancelButtonsProps> = ({
	onCancel,
	loading,
	cancelButtonProps,
	saveButtonProps,
	saveButtonType = 'submit',
	saveButtonLabel = 'Save',
	cancelButtonLabel = 'Cancel',
	customWrapperStyles,
	customButtonStyles,
}: AppSubmitCancelButtonsProps) => {
	return (
		<Box
			sx={{
				pt: 6,
				px: 9.75,
				mx: -9.75,
				boxShadow: '0px -5px 7px -3px rgba(34, 60, 80, 0.29)',
				textAlign: 'right',
				...customWrapperStyles,
			}}
		>
			<Button
				variant={'contained'}
				color={'secondary'}
				size={'large'}
				disableElevation
				sx={{
					mr: 3,
					width: '5.75rem',
					maxWidth: '5.75rem',
					...customButtonStyles,
				}}
				onClick={onCancel}
				{...cancelButtonProps}
			>
				{cancelButtonLabel}
			</Button>

			<Button
				size={'large'}
				variant='contained'
				type={saveButtonType}
				color={'primary'}
				sx={{
					width: '4.6875rem',
					maxWidth: '4.6875rem',
					...customButtonStyles,
				}}
				{...saveButtonProps}
			>
				{loading ? (
					<CircularProgress size={28} color={'inherit'} />
				) : (
					saveButtonLabel
				)}
			</Button>
		</Box>
	)
}

export default AppSubmitCancelButtons
